import { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { useAppSelector } from '../hooks/reduxHooks';
import { useFactoryScope } from '../hooks/useFactoryScope';

interface FactorySwitcherProps {
  className?: string;
}

/** Genel admin için üst menüdeki fabrika seçici: Tüm Fabrikalar veya tek fabrika. */
const FactorySwitcher = ({ className = '' }: FactorySwitcherProps) => {
  const factories = useAppSelector((state) => state.factory.factories);
  const { factoryId, setFactoryId } = useFactoryScope();

  return (
    <label className={`relative flex items-center ${className}`}>
      <span className="sr-only">Fabrika seçimi</span>
      <BuildingOffice2Icon className="pointer-events-none absolute left-2.5 h-5 w-5 text-blue-600" />
      <select
        value={factoryId ?? ''}
        onChange={(e) => setFactoryId(e.target.value ? Number(e.target.value) : null)}
        className="w-full rounded-md border border-blue-200 bg-blue-50 py-1.5 pl-9 pr-8 text-sm font-semibold text-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">Tüm Fabrikalar</option>
        {factories.map((factory) => (
          <option key={factory.id} value={factory.id}>
            {factory.name}
          </option>
        ))}
      </select>
    </label>
  );
};

export default FactorySwitcher;
